import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const EnVeiInn = ({ title, titleId, desc, descId }: SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 96 95"
    aria-labelledby={titleId}
    aria-describedby={descId}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#565FEA"
      d="M0 95h24.902l27.823-46.902L43.812 95H67.91L96 47.5 67.844 0H42.812l27.82 46.768L24.169 0H.068l28.086 47.5z"
    />
  </svg>
);
export default EnVeiInn;
